import qs from 'qs'
import SuperagentApi from '../assets/utils/superagent'

const baseURL =
  _.get(Wiz, 'globalSettings.globalConfig.diyApiBase') || localStorage.getItem('DiyApiBase')
const superagentApi = new SuperagentApi({ baseUrl: baseURL })
const token = Wiz.AuthHooks.GetToken()
const headers = {
  Authorization: `Bearer ${localStorage.getItem('authorization') || token}`,
  'X-Wiz-Tenant-Id': JSON.parse(window.localStorage.getItem('CurrentUser'))?.TenantId || '',
}

export default class projectNavigationTenant {
  static async getTenantList(payload) {
    const [err, res] = await superagentApi.post(
      `/api/Tenant/GetTenantList?${qs.stringify(payload)}`,
      { data: {}, headers }
    )
    return [err, res]
  }
  static async getCurrentTenantList(payload) {
    const [err, res] = await superagentApi.post(
      `/api/Tenant/GetCurrentTenantList?${qs.stringify(payload)}`,
      { data: {}, headers }
    )
    return [err, res]
  }
  static async getTableData(payload) {
    const [err, res] = await superagentApi.post('/api/FormEngine/getTableData', {
      data: payload,
      headers,
    })
    return [err, res]
  }
}
